import {useQuery} from "@tanstack/react-query";
import {ProductExDetailSearchParamType} from "../interface";
import {readProductDetailEx} from "../../../../../api/product/ProductExApi";
import {productExDetailInit} from "../state";

type Props = {
    param: ProductExDetailSearchParamType;
};

export const useReadProductDetailEx = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readProductDetailEx", param],
        queryFn: async () => await readProductDetailEx(param),
        select: (res) => res?.data.result ?? productExDetailInit,
        enabled: param.newErpProductid !== ""
    });

    return {data};
};
